import { gql } from "@apollo/client";
import ReelViewAvatar, { ReelViewAvatarFragment } from "molecules/ReelAvatar";
import React from "react";

import VideoPlayerHeader from "./VideoPlayerHeader";

export const ReelPlayerHeaderFragment = gql`
  fragment ReelPlayerHeaderFragment on ReelView {
    title
    eventsCount
    team {
      id
      name
    }
    ...ReelViewAvatarFragment
  }
  ${ReelViewAvatarFragment}
`;

// Reel title, team name and highlight count of a reel.
export default function ReelPlayerHeader({ reelView, action }) {
  if (!reelView) return null;

  const highlights = `${reelView.eventsCount} ${reelView.eventsCount === 1 ? "highlight" : "highlights"}`;

  return (
    <VideoPlayerHeader
      // team reels have no avatar; an empty one would still take the slot and its gap
      avatar={reelView.isPlayerReel && <ReelViewAvatar reelView={reelView} size={40} />}
      title={reelView.title}
      subtitle={[reelView.team?.name, highlights].filter(Boolean).join(" · ")}
      action={action}
    />
  );
}
